export const SIGN_BUBBLE_BG_COLOR = "rgba(40, 40, 40, 0.92)";
export const SIGN_BUBBLE_BORDER_COLOR = "rgba(255, 255, 255, 0.4)";
export const SIGN_BUBBLE_TEXT_COLOR = "#ffffff";
export const SIGN_BUBBLE_FONT_SIZE = 16;
export const SIGN_BUBBLE_LINE_HEIGHT = 20;
export const SIGN_BUBBLE_PADDING_X = 14;
export const SIGN_BUBBLE_PADDING_Y = 10;
export const SIGN_BUBBLE_MAX_WIDTH = 280;
export const SIGN_BUBBLE_MIN_WIDTH = 120;
export const SIGN_BUBBLE_BORDER_RADIUS = 8;
export const SIGN_BUBBLE_TAIL_WIDTH = 14;
export const SIGN_BUBBLE_TAIL_HEIGHT = 10;
export const SIGN_BUBBLE_GAP_FROM_CELL = 6;
export const SIGN_BUBBLE_FADE_IN_MS = 150;
export const SIGN_BUBBLE_FADE_OUT_MS = 200;
export const SIGN_BUBBLE_VIEWPORT_MARGIN = 12;
